import { render, staticRenderFns } from "./StatChart.vue?vue&type=template&id=4de8d0e7&"
import script from "./StatChart.vue?vue&type=script&lang=js&"
export * from "./StatChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports